//lib
import { Field, FieldArray, useFormikContext } from "formik";

//component
import Row from "./row";
import Col from "./col";

export default function Checkbox(props) {
  const {
    type,
    label,
    checked,
    labelValue,
    labelTrue,
    labelFalse,
    name,
    options,
    className,
    classNameCheckbox,
    onChange,
  } = props;

  const formik = useFormikContext();

  return (
    <>
      <Col className={`element _checkbox ${className ? className : ""}`}>
        {label && (
          <Row>
            <label>{label}</label>
          </Row>
        )}
        {type === "array" ? (
          <FieldArray
            name={name}
            render={(arrayHelpers) => (
              <Row className="row-gap-2 items-center">
                {options.map((listing, index) => (
                  <Col
                    key={index}
                    className={`checkbox-button ${
                      classNameCheckbox ? classNameCheckbox : ""
                    }`}
                  >
                    <Row
                      className={`checkbox-wrapper ${
                        formik?.values[name].includes(listing.value)
                          ? "active"
                          : ""
                      }`}
                    >
                      <label key={listing.id}>
                        <Field
                          name={name}
                          type="checkbox"
                          value={listing.value}
                          checked={
                            name
                              ? formik?.values[name].includes(listing.value)
                              : ""
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              arrayHelpers.push(listing.value);
                            } else {
                              const idx = formik?.values[name].indexOf(
                                listing.value
                              );
                              arrayHelpers.remove(idx);
                            }
                          }}
                        />
                        <span className="checkbox"></span>
                        <span>&nbsp;&nbsp;{listing.label}</span>
                      </label>
                    </Row>
                  </Col>
                ))}
              </Row>
            )}
          />
        ) : (
          <Col
            className={`col-2 checkbox-button flex items-center ${classNameCheckbox}`}
          >
            <Row className="checkbox-wrapper">
              <label>
                <input
                  type="checkbox"
                  name={name}
                  checked={checked}
                  onChange={onChange ?? undefined}
                />
                <span className="checkbox"></span>
              </label>
            </Row>

            {labelValue && (
              <span>
                {labelValue
                  ? labelValue
                  : formik?.values[name] === true && labelTrue
                  ? labelTrue
                  : formik?.values[name] === false && labelFalse
                  ? labelFalse
                  : formik?.values[name].toString()}
              </span>
            )}
          </Col>
        )}
      </Col>
      {formik?.errors && formik.errors[name] ? (
        <Row className="element _errors">{formik.errors[name]}</Row>
      ) : null}
    </>
  );
}
